import { assert } from 'cadenza/utils/custom-error';

const BUFFER_SIZE = 1;

/**
 * Collects AbortControllers for later cancellation. It only remembers the amount of AbortControllers
 * set by #bufferSize.
 */
export class MultiExecutionHelper {

  #abortControllers = [];
  #bufferSize;

  constructor (bufferSize = BUFFER_SIZE) {
    this.#bufferSize = bufferSize;
  }

  submit (abortController) {
    assert(abortController != null, 'abortController is mandatory');
    this.#abortControllers.push(abortController);
    if (this.#abortControllers.length > this.#bufferSize) {
      this.#abortControllers.shift();
    }
  }

  remove (abortController) {
    this.#abortControllers.splice(this.#abortControllers.indexOf(abortController), 1);
  }

  cancel () {
    for (const abortController of this.#abortControllers) {
      abortController.abort();
    }
    this.#abortControllers = [];
  }

}
